/**
 * Created by pbo on 29/04/16.
 */
angular.module('taric.duty.calculate', ['taric.model.cd', 'taric.duty.calculate.commodity', 'taric.duty.calculate.data', 'taric.duty.calculate.units', 'taric.duty.calculate.adco', 'taric.duty.calculate.results', 'taric.duty.calculate.doc', 'taric.duty.calculate.security'])
    .controller('CalculateDutyCtrl', function ($window, $translatePartialLoader, $state, $stateParams, CalculateDutyModel) {
        var calculateDutyCtrl = this;
        
        // this is the minimum size before swithcing to mobile size
        var mobileSize = 660;
        
        calculateDutyCtrl.isSmallScreen = false;
        calculateDutyCtrl.typeScreen = 'tabs';
        
        calculateDutyCtrl.init = function () {
            
        	calculateDutyCtrl.model = CalculateDutyModel;
            
            if ($window.innerWidth < mobileSize) {
            	calculateDutyCtrl.isSmallScreen = true;
            	calculateDutyCtrl.typeScreen = 'pills';
            } else {

            	calculateDutyCtrl.isSmallScreen = false;
            	calculateDutyCtrl.typeScreen = 'tabs';
            }
        };

        calculateDutyCtrl.returnToMeasuresForNomenclature = function () {
            $state.go('taric.measure.mcc', {frm : 'calDuties'});
        };

        calculateDutyCtrl.showBackToMeasures = function () {
            return $stateParams.frm === 'taric.measure.mcc';
        };
        
        angular.element($window).on('resize', function() {

        	var el = document.querySelector("#calDutyTabs ul");
        	if (el) {
	            if ($window.innerWidth < mobileSize) {
	            	if (el)
	            		el.setAttribute("class", "nav nav-tabs nav-pills nav-stacked");
	            } else {

            		el.setAttribute("class", "nav nav-tabs");
	            }
        	}
        });
    });


// WEBPACK FOOTER //
// ./app/taric/duties/calculate/cd.js